import { render, staticRenderFns } from "./add-detail.vue?vue&type=template&id=4d2f32bb"
import script from "./add-detail.vue?vue&type=script&lang=ts"
export * from "./add-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports